<template>
  <div>
    <h2 class="content-block">User Information</h2>

    <div class="content-block dx-card responsive-paddings">
      <div class="form-avatar">
        <img :src="imageSrc" />
      </div>
      <span>Use this form to see and update your user's data for the Enfays Cloud system. To update information change the fields and click the save button. It is not allowed to change your username, if you need to do so, please contact an administrator</span>
    </div>

    <div class="content-block dx-card responsive-paddings">
      <form @submit.prevent="updateUserInfo">
      <DxForm
        label-location="top"
        :form-data="user"
        :col-count-by-screen="colCountByScreen">
        <DxSimpleItem data-field="name" ><DxLabel text="Name" /></DxSimpleItem>
        <DxSimpleItem data-field="lastName" ><DxLabel text="Last Name" /></DxSimpleItem>
        <DxSimpleItem :editor-options="{disabled: true}" data-field="username" ><DxLabel text="Username (login)" /></DxSimpleItem>
        <DxSimpleItem data-field="email" ><DxLabel text="email" /></DxSimpleItem>
        <DxSimpleItem :editor-options="{disabled: true}" data-field="createdAt"
        ><DxLabel text="Registry date" /></DxSimpleItem> 
        <DxSimpleItem
          :col-span="3"
          :editor-options="{ height: 110, maxLength:300 }"
          data-field="description"
          editor-type="dxTextArea"
        ><DxLabel text="Notes" /></DxSimpleItem>
        <DxButtonItem :button-options="{ text: 'Save Changes', type:'success', useSubmitBehavior: true}"/>
        <DxButtonItem :button-options="{ text: 'Change Password', type:'normal', useSubmitBehavior: false, onClick: showSetUserPass }"/>
      </DxForm>
      </form>
    </div>

    <DxPopup
      content-template="change-passwd-form"
      :title="'Change My Password'"
      max-width="350px"
      max-height="450px"
      :show-close-button="true"
      v-model:visible="isSetPasswordPopupVisible"
      :hide-on-outside-click="true">
      <template #change-passwd-form>
        <DxScrollView width="100%" height="100%" >
          <SetPasswordForm :username="user.username" @request-finish="hideSetUserPass"/>
        </DxScrollView>
      </template>            
    </DxPopup>
  </div>
</template>

<script>
import SetPasswordForm from './settings-change-password.vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import {DxForm, DxSimpleItem, DxButtonItem, DxLabel} from "devextreme-vue/form";
import 'devextreme-vue/text-area';
import RawDataService from '../services/RawDataServiceTemplate';
import notify from 'devextreme/ui/notify';
import appInfo from "../app-info";

import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
const myUserDataService = new RawDataService('users/me');

export default {
  props: {
  },
  components: {
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxButtonItem,
    DxPopup,
    DxScrollView,
    SetPasswordForm,
  },
  setup() {
    const store = useStore();
    const avatarPath = ref(store.state.user.avatarImgPath);
    const user = reactive({});
    let colCountByScreen = {
      xs: 1,
      sm: 2,
      md: 3,
      lg: 3,
    };

    myUserDataService.getAll()
    .then( res => { 
      Object.assign(user, res);
      if (res.avatarImgPath){
        avatarPath.value = res.avatarImgPath;
      }
    })
    .catch( err => { console.log(err) })

    const updateUserInfo = () => {
      myUserDataService.update('', user)
      .then( res => { notify(res.message||"User information updated", "success", 3000); })
      .catch( err => { notify(err.message||"error sending org information", "error", 5000); })
    }
    const imageSrc = computed(() => appInfo.appURL + '/' + avatarPath.value );
    const isSetPasswordPopupVisible = ref(false);
    const showSetUserPass = () => {
      isSetPasswordPopupVisible.value = true;
    }
    const hideSetUserPass = (e) => {
      if (e) isSetPasswordPopupVisible.value = false;
    }

    return{
      avatarPath,
      colCountByScreen,
      updateUserInfo,
      imageSrc,
      user,
      showSetUserPass,
      hideSetUserPass,
      isSetPasswordPopupVisible,
    }
  },
};
</script>

<style lang="scss">
.form-avatar {
  float: left;
  height: 125px;
  width: 125px;
  margin-right: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  overflow: hidden;

  img {
    height: 120px;
    display: block;
    margin: 0 auto;
  }
}
</style>
